export default {"src":"/_next/static/media/view-black-yes.04501665.svg","height":18,"width":30,"blurWidth":0,"blurHeight":0};